import React from 'react';

import Loader from '../../../../components/Loader';
import Page from '../../../../components/Page';
import HTTPManager from "../../../../utils/httpRequestManager";
import { toast, ToastContainer } from 'react-toastify';
import {Switch, Grid, Stack, Typography, Box, Card, Button} from '@mui/material';
import { AddOutlined, MinimizeOutlined } from '@mui/icons-material';
import FTextField from '../../../../components/formComponents/components/textField';


export default class TipSuggestions extends React.Component{
    httpManager = new HTTPManager()

    constructor(props){
        super(props)
        this.state={
            isLoading: true,
            checked:false,
            maxCount: 3,
            suggestions:[
                ''
            ]
        }
        this.handleChange = this.handleChange.bind(this)
        this.saveSuggestion = this.saveSuggestion.bind(this)
    }

    saveSuggestion(){
        if(this.state.checked){
            var sugg = [];
            var exist = false;
            var zeroExist = false;
            this.state.suggestions.forEach((m, i)=>{
                if(sugg.indexOf(m) === -1 && m !== '' && Number(m)>0){
                    sugg.push(m)
                }
                else if(Number(m)===0){
                    zeroExist=true;
                }
                else if(sugg.indexOf(m) !== -1){
                    exist = true;
                }
                if(i === this.state.suggestions.length-1){
                    if(exist){
                        toast.dismiss();
                        toast.error('Please enter various tip suggestions.', {
                            position: "top-center",
                            autoClose: 5000,
                            closeButton:false,
                            hideProgressBar: true,
                            closeOnClick: false,
                            pauseOnHover: false,
                            draggable: false,
                            progress: undefined,
                        });
                    }
                    else if(zeroExist){
                        toast.dismiss();
                        toast.error('Percentage should be greater than zero.', {
                            position: "top-center",
                            autoClose: 5000,
                            closeButton:false,
                            hideProgressBar: true,
                            closeOnClick: false,
                            pauseOnHover: false,
                            draggable: false,
                            progress: undefined,
                        });
                    }
                    else if(sugg.length !== this.state.suggestions.length){
                        toast.dismiss();
                        toast.error('Please fill all the fields.', {
                            position: "top-center",
                            autoClose: 5000,
                            closeButton:false,
                            hideProgressBar: true,
                            closeOnClick: false,
                            pauseOnHover: false,
                            draggable: false,
                            progress: undefined,
                        });
                    }
                    else{
                        this.httpManager.postRequest('/merchant/tipsuggestion/saveSettings', {tipSuggestionStatus: this.state.checked ? 'Yes' : 'No'}).then(r=>{
                            this.httpManager.postRequest('/merchant/tipsuggestion/save',{suggestions: this.state.suggestions}).then(r=>{
                                toast.dismiss();
                                toast.success(r.msg, {
                                    position: "top-center",
                                    autoClose: 5000,
                                    closeButton:false,
                                    hideProgressBar: true,
                                    closeOnClick: false,
                                    pauseOnHover: false,
                                    draggable: false,
                                    progress: undefined,
                                });
                            })
                        })
                    }
                }
            })
        }
        else{
            this.httpManager.postRequest('/merchant/tipsuggestion/saveSettings', {tipSuggestionStatus: this.state.checked ? 'Yes' : 'No'}).then(r=>{
                this.httpManager.postRequest('/merchant/tipsuggestion/save',{suggestions: []}).then(r=>{
                    toast.dismiss();
                    toast.success(r.msg, {
                        position: "top-center",
                        autoClose: 5000,
                        closeButton:false,
                        hideProgressBar: true,
                        closeOnClick: false,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                    });
                })
            })
        }
    }

    handleChange = (event) => {
        this.setState({checked: event.target.checked});
        if(event.target.checked && this.state.suggestions.length ===0){
            this.setState({suggestions:['']})
        }
        else{
            this.httpManager.postRequest('/merchant/tipsuggestion/saveSettings', {tipSuggestionStatus: 'No'}).then(r=>{
                this.httpManager.postRequest('/merchant/tipsuggestion/save',{suggestions: []}).then(r=>{
                    toast.dismiss();
                    toast.success(r.msg, {
                        position: "top-center",
                        autoClose: 5000,
                        closeButton:false,
                        hideProgressBar: true,
                        closeOnClick: false,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                    });
                })
            })
        }
        // if(!event.target.checked){
        //     this.setState({suggestions:['']})
        // }
      };

    componentDidMount(){
        this.getDetails()
    }

    getDetails(){
        this.httpManager.getRequest('/merchant/tipsuggestion/get').then(r=>{ 
            console.log(r.data)
           if(r.data.tipSuggestionSetting.id !== undefined){ 
            console.log("YES COMING")
            var suggestions = r.data.tipSuggestions.map(m=>m.suggestionPercentage).sort();
            this.setState({suggestions: suggestions}, ()=>{
                this.setState({checked : r.data.tipSuggestionSetting.tipSuggestionStatus === 'Yes' ? true : false})
            })
           }
           else{
            this.setState({suggestions:['']}, ()=>{
                this.setState({checked: false})
            })
           }
        })
        this.setState({isLoading: false})
    }

    render(){
        return <Page title="Tax | Astro POS">
                {this.state.isLoading && <Loader show={this.state.isLoading} />}
                <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss={false}
                draggable={false}
                pauseOnHover={false}
                />  
                 <Box sx={{ width: '100%' }}> 
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                        Tip Suggestion Management
                        </Typography> 
                    </Stack>
                    <Card style={{minHeight:'200px', padding:'1rem'}}>
                        <Grid container>
                        <Grid item xs={9}>
                            Show Tips Suggestion in Receipt Print
                        </Grid>
                        <Grid item xs={3}>
                            <Switch checked={this.state.checked}
                                onChange={this.handleChange}
                                inputProps={{ 'aria-label': 'controlled' }}
                                />
                        </Grid>

                        {this.state.checked && <Grid item xs={12}>
                            {this.state.suggestions.map((r, i)=>{
                                return <Grid item xs={12} style={{display:'flex',margin:'1rem 0', alignItems:'center' ,flexDirection:'row'}}>
                                   <Grid item xs={3}></Grid>  <Grid item xs={5}>
                                        <FTextField label="Tips Suggestion %" fullWidth placeholder="Tips Suggestion %" name={'tipPercentage'+i} value={r} onChange={(e)=>{
                                            // if(this.state.suggestions.indexOf(e.target.value) === -1){
                                                var sugg = Object.assign([], this.state.suggestions)
                                                sugg[i] = e.target.value
                                                this.setState({suggestions: sugg})
                                            // }
                                        }} format={'number'} maxLength={2}
                                        />
                                    </Grid> 
                                    <Grid item xs={1}>
                                        {i!==0 && <MinimizeOutlined onClick={()=>{
                                            var sugg = Object.assign([], this.state.suggestions)
                                            sugg.splice(i, 1)
                                            this.setState({suggestions: sugg})
                                        }}/>}
                                        {i===0 && <AddOutlined onClick={()=>{
                                            if(this.state.suggestions.length < this.state.maxCount){
                                                var sugg = Object.assign([], this.state.suggestions)
                                                sugg.push('')
                                                this.setState({suggestions: sugg})
                                            }
                                            else{
                                                toast.dismiss();
                                                toast.error("You cannot add more than "+this.state.maxCount+" suggestions", {
                                                    position: "top-center",
                                                    autoClose: 5000,
                                                    closeButton:false,
                                                    hideProgressBar: true,
                                                    closeOnClick: false,
                                                    pauseOnHover: false,
                                                    draggable: false,
                                                    progress: undefined,
                                                });
                                            }
                                        }}/>}
                                    </Grid>
                                    <Grid item xs={3}></Grid> 
                                </Grid>
                            })} 


                        <Grid item xs={12} style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                            <Button variant={'contained'} style={{width:'max-content'}} onClick={this.saveSuggestion}>
                                Save
                            </Button>
                        </Grid>
                        </Grid>}

                        </Grid>
                    </Card>
               </Box>
                </Page>
    }
}